import { LitElement, css, html, nothing } from "lit";
import { customElement } from "lit/decorators.js";
import { AtlFooterLinkProps } from "./footer.props.ts";

import * as TagNames from "./footer.tagnames.ts";
import { PlaceholderEnums } from "../placeholders/index.ts";
import footerLinkStyles from "./footer-link.scss?inline";

@customElement(TagNames.FooterLink)
export class AtlFooterLink extends LitElement implements AtlFooterLinkProps {
  declare href: string;
  declare target: string;
  declare rel: string;
  declare showHidden?: boolean;
  declare showPlaceholder?: boolean;

  static properties = {
    href: { type: String },
    target: { type: String },
    rel: { type: String },
    showHidden: { attribute: "show-hidden", type: Boolean },
    showPlaceholder: { attribute: "show-placeholder", type: Boolean },
  };

  constructor() {
    super();
    this.rel = "noreferrer";
  }

  static styles = [
    footerLinkStyles,
    css`
      :host {
        display: contents;
      }
    `,
  ];

  render() {
    if (this.showHidden) return nothing;

    if (this.showPlaceholder) {
      return html`
        <atlantis-span-placeholder
          size=${PlaceholderEnums.SpanPlaceholderSizes.Small}
          glow
          class="footer-link"
        ></atlantis-span-placeholder>
      `;
    }

    if (this.href) {
      return html`
        <a
          type="button"
          class="footer-link"
          href="${this.href}"
          target="${this.target || nothing}"
          rel="${this.rel}"
          aria-label="${this.ariaLabel || nothing}"
        >
          <slot></slot>
        </a>
      `;
    }
    return html`
      <button
        type="button"
        class="footer-link"
        aria-label="${this.ariaLabel || nothing}"
      >
        <slot></slot>
      </button>
    `;
  }
}
